import { Injectable } from '@angular/core';
import {
  LoyaltyProgramCategory,
  SuccessButton,
  SuccessButtonGroup,
  TranslationKeyType,
} from '@rd/types';

type checkoutPageText = 'checkoutReminderMessage';
export type RcCheckoutPageTextMap = Record<
  checkoutPageText,
  TranslationKeyType | null
>;

type successPageText =
  | 'confirmedStatusMessage'
  | 'failedStatusMessage'
  | 'pendingStatusMessage';
export type RcSuccessPageTextMap = Record<
  successPageText,
  TranslationKeyType | null
>;

@Injectable({
  providedIn: 'root',
})
export class RedeemCashSettingService {
  shouldAllowRedeemToOtherAccount = false;
  shouldAllowEditCashValue = false;
  defaultEnrollmentListCategory = LoyaltyProgramCategory.CashbackToAccount;
  hasPromocode = false;

  /*
  ====================================
    Checkout page-only settings
  ====================================
  */

  checkoutPageText: RcCheckoutPageTextMap = {
    checkoutReminderMessage: {
      translationKey: 'redeem_cash_v2.checkout.receive_cash_reminder',
    },
  };

  successLinkedDialogButton: SuccessButton = {
    buttonClass: 'ok-button',
    buttonText: 'redeem_cash_v2.membership_success_dialog.ok_text',
    buttonTheme: 'primary',
    redirectURL: null,
  };

  failedLinkedDialogButton: SuccessButton = {
    buttonClass: 'ok-button',
    buttonText: 'redeem_cash_v2.membership_failed_dialog.try_again_text',
    buttonTheme: 'primary',
    redirectURL: null,
  };

  /*
  ====================================
    Review page-only settings
  ====================================
  */

  shouldDisplayMembershipDetailsOnReviewPage = true;
  shouldFilterSupplementaryCardHolder = false;
  shouldRequireAgreeTnc = false;

  /*
  ====================================
    Success page-only settings
  ====================================
  */

  shouldDisplayMembershipDetailsOnSuccessPage = true;

  private defaultSuccessPageText: RcSuccessPageTextMap = {
    confirmedStatusMessage: null,
    failedStatusMessage: {
      translationKey: 'redeem_cash_v2.success.contact_us',
    },
    pendingStatusMessage: {
      translationKey: 'redeem_cash_v2.success.notification_disclaimer',
    },
  };

  protected successPageTextOverrides: Partial<RcSuccessPageTextMap> = {};

  get successPageText(): RcSuccessPageTextMap {
    return {
      ...this.defaultSuccessPageText,
      ...this.successPageTextOverrides,
    };
  }

  get successButtons(): SuccessButtonGroup {
    const makeAnotherRedemptionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'redeem_cash_v2.success.make_another_redemption',
      buttonTheme: 'primary',
      redirectURL: '/',
    };

    const toPointsActivityButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'redeem_cash_v2.success.see_points_activity',
      buttonTheme: 'secondary',
      redirectURL: '/points_activity',
    };

    return {
      confirmed: [toPointsActivityButton, makeAnotherRedemptionButton],
      pending: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toPointsActivityButton, buttonTheme: 'primary' },
      ],
      failed: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toPointsActivityButton, buttonTheme: 'primary' },
      ],
    };
  }
}
